export default __webpack_public_path__ + "69c6e1fac878d70dda782d86aa41602a.png";